var map = {
	"./customers/customer.module": [
		"../../../../../src/app/customers/customer.module.ts",
		0
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/dashboard/dashboard.module.ts",
		5
	],
	"./home/home.module": [
		"../../../../../src/app/home/home.module.ts",
		4
	],
	"./login/login.module": [
		"../../../../../src/app/login/login.module.ts",
		2
	],
	"./pages/pages.module": [
		"../../../../../src/app/pages/pages.module.ts",
		1
	],
	"./sales/sales.module": [
		"../../../../../src/app/sales/sales.module.ts",
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "../../../../../src async recursive";


//////////////////
// WEBPACK FOOTER
// C:/Software Development/Devpark/biz-app/src async
// module id = ../../../../../src async recursive
// module chunks = 7